var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCheckV2(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M21.3745 4.45312H19.7362C19.5065 4.45312 19.2885 4.55859 19.1479 4.73906L9.48462 16.9805L4.85103 11.1094C4.78093 11.0204 4.69159 10.9484 4.5897 10.8989C4.48781 10.8494 4.37603 10.8236 4.26274 10.8234H2.62446C2.46743 10.8234 2.38071 11.0039 2.47681 11.1258L8.89634 19.2586C9.19634 19.6383 9.7729 19.6383 10.0752 19.2586L21.5221 4.75313C21.6182 4.63359 21.5315 4.45312 21.3745 4.45312Z",
    fill: "#52C41A"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCheckV2);
export default __webpack_public_path__ + "static/media/check-v2.25031974.svg";
export { ForwardRef as ReactComponent };